<template>
    <div class="card">
        <div class="card-body">
            <div class="customize-calendar">
                <full-calendar :config="config" :events="events" />
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import 'fullcalendar/dist/locale/es'
	export default {
    name: 'calendar',
    props: ['_event'],
    data: () => {
        return {
            events: [],
            config: { 
                locale: 'es',
                defaultView: 'month',
                eventRender: function(event, element) {
                    console.log(event)
                }
            },
        }
    },
  created(){
    showLoader()
    // TOMAR LOS VALORES ENVIADOS AL COMPONENTE
    this.events = this._event
    hideLoader()
  }
}
</script>
